import { createSlice } from '@reduxjs/toolkit';
import { displayInitialState } from './display.defaults';

export const homeArtistsDisplaySlice = createSlice({
  name: 'display',
  initialState: displayInitialState,
  reducers: {
    OPEN_FILTERS_HomeArtists: (state) => {
      state.isFiltersDialogOpen = true;
    },
    CLOSE_FILTERS_HomeArtists: (state) => {
      state.isFiltersDialogOpen = false;
    },
  },
});
